import React from 'react';
import styles from './NavHeader.module.scss';

import Author from '../Author';
import MenuPost from '../MenuPost';

const NavHeader = () => (
  <div className={styles['header']}>
    <div className={styles['header__left']}>
      <Author />
    </div>
    <div className={styles['header__right']}>
      <MenuPost horizontal bold />
    </div>
  </div>
);

export default NavHeader;
